<template>
  <div class="cann-group">
    <Notes
      :notes="getAllNotes"
      :loading="isLoading"
      :title="$t('notes.types.cannGroup')"
      :max-chars="getClientConfig.notesSettings.maxLength"
      :is-cann-group="true"
      :notifications="!!leafNode.totalNotes"
      @post="postNewCannGroupNote(leafNode.key, $event)"
      @menu-open="fetchSingleCannGroupNotes(leafNode.key)"
      @delete="deleteCannGroupNote(leafNode.key, $event)"
      @update="updateCannGroupNote(leafNode.key, $event)"
    />
  </div>
</template>

<script>
import { useNotes } from '@/composables/notes';
import { useContextStore } from '@/stores/context';
import { useNotesStore } from '@/stores/notes';
import { useScenariosStore } from '@/stores/scenarios';
import { useWorkpackagesStore } from '@/stores/workpackages';
import contextEnum from '@enums/note-contexts';
import { mapActions, mapState } from 'pinia';

export default {
  name: 'CannGroupNote',
  props: {
    leafNode: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const workpackagesStore = useWorkpackagesStore();
    const scenariosStore = useScenariosStore();
    const {
      isNotesLoading,
      getAllNotes,
      getNotes,
      postNewNote,
      fetchAllNotes,
      deleteCurrentNote,
      updateCurrentNote,
    } = useNotes(contextEnum.cannGroup, {
      id: props.leafNode.key,
      scenarioId: scenariosStore.selectedScenario._id,
      workpackageId: workpackagesStore.selectedWorkpackage._id,
      context: contextEnum.cannGroup,
    });

    return {
      isNotesLoading,
      getAllNotes,
      getNotes,
      postNewNote,
      fetchAllNotes,
      deleteCurrentNote,
      updateCurrentNote,
    };
  },

  data() {
    return { isLoading: false };
  },

  computed: {
    ...mapState(useWorkpackagesStore, ['selectedWorkpackage']),
    ...mapState(useScenariosStore, ['selectedScenario']),
    ...mapState(useContextStore, ['getClientConfig']),
  },
  methods: {
    ...mapActions(useNotesStore, ['fetchCannGroupNotes', 'postNote', 'updateNote', 'deleteNote']),

    async postNewCannGroupNote(id, { message }) {
      this.isLoading = true;
      await this.postNote({
        params: {
          message,
          id,
          context: contextEnum.cannGroup,
          scenarioId: this.selectedScenario._id,
          workpackageId: this.selectedWorkpackage._id,
        },
        options: { storeToUpdate: 'scenario', mutationName: 'updateCannGroupNoteCountMutation' },
      });
      this.isLoading = false;
    },

    async fetchSingleCannGroupNotes(id) {
      this.isLoading = true;
      await this.fetchCannGroupNotes({
        params: {
          id,
          scenarioId: this.selectedScenario._id,
          context: contextEnum.cannGroup,
        },
      });
      this.isLoading = false;
    },

    async updateCannGroupNote(id, { message, note }) {
      this.isLoading = true;
      await this.updateNote({
        params: {
          id,
          context: contextEnum.cannGroup,
          message,
          noteId: note._id,
        },
      });
      this.isLoading = false;
    },

    async deleteCannGroupNote(id, { noteId }) {
      this.isLoading = true;
      await this.deleteNote({
        params: {
          id,
          context: contextEnum.cannGroup,
          noteId,
        },
        options: { storeToUpdate: 'scenario', mutationName: 'updateCannGroupNoteCountMutation' },
      });
      this.isLoading = false;
    },
  },
};
</script>
